import React from "react";
import styled from "styled-components";
import { BlackXSrc } from "../../../resources/Assets";

export default (props) => {
  return (
    <HeaderContainer>
      <ButtonImageDiv />
      <ButtonImageDiv onClick={props.rightClickEvent}>
        <img src={BlackXSrc} />
      </ButtonImageDiv>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  padding: 0px 16px 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const ButtonImageDiv = styled.div`
  width: 40px;
  height: 40px;
`;
